import { memo } from 'react';
import * as HotToast from 'react-hot-toast';
import { colorsNew } from 'root/src/client/web/commonStyles';
import { DEFAULT_MODAL_OPTIONS } from 'root/src/client/v2/common/contexts/modal.context';
export const Toaster = memo(() => {
    return (<HotToast.Toaster containerStyle={{
            zIndex: DEFAULT_MODAL_OPTIONS.zIndex + 1000,
        }} toastOptions={{
            success: {
                style: {
                    backgroundColor: colorsNew.primary,
                    color: '#fff',
                },
            },
            error: {
                style: {
                    color: '#ddd',
                    backgroundColor: colorsNew.red,
                },
            },
        }} position="bottom-right"/>);
});
